module.exports = __webpack_public_path__ + "img/08.56b54fda.png";